export default __webpack_public_path__ + "static/media/session9.c82181e0.svg";